<template>
  <div :class="'video ' + className">
    <video
      class="d-block w-100 h-100"
      width="1600"
      height="1600"
      muted
      loop
      controls
      playsinline="playsinline"
      webkit-playsinline="true"
      preload="metadata"
    >
      <source :src="url" type="video/mp4" />
    </video>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names,vue/no-reserved-component-names
  name: "Video",
  props: {
    url: {
      type: String,
      default: "",
    },
    className: {
      type: String,
      default: "",
    },
  },
};
</script>
